import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css'],
})
export class TicketsComponent {
  constructor(
    private apiService: ApiService,
    private datePipe: DatePipe,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      dateRange: new FormGroup({
        start: new FormControl(),
        end: new FormControl(),
      }),
    });
  }

  dateRangeChange(
    dateRangeStart: HTMLInputElement,
    dateRangeEnd: HTMLInputElement
  ) {
    this.startDate = dateRangeStart.value;
    this.endDate = dateRangeEnd.value;
    this.ticketsData = [];
    const dataTable = $('#ticketsDataTable').DataTable();
    dataTable.ajax.reload();
  }

  clearDateRange() {
    const dateRangeControl = this.form.get('dateRange');
    if (dateRangeControl) {
      dateRangeControl.reset();
      this.startDate = '';
      this.endDate = '';
      this.ticketsData = [];
      const dataTable = $('#ticketsDataTable').DataTable();
      dataTable.ajax.reload();
    }
  }

  form: FormGroup;
  startDate: any;
  endDate: any;
  isLoading = true;
  search = '';
  ticketsData: any = [];
  dtOptions: DataTables.Settings = {};
  currentSortParam = 'startDate|desc';

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full',
      ordering: true,
      processing: true,
      serverSide: true,
      searching: true,
      search: true,
      columns: [
        {
          title: 'Nume',
          data: 'firstName',
        },
        {
          title: 'Prenume',
          data: 'lastName',
        },
        {
          title: 'E-mail',
          data: 'email',
        },
        {
          title: 'Număr de înmatriculare',
          data: 'licensePlate',
        },
        {
          title: 'Zona',
          data: 'location',
          render: (data: any, type: any, row: any, meta: any) => {
            const zoneName = this.getZoneNameByType(data);
            return zoneName || '-';
          },
        },
        {
          title: 'Operator',
          data: 'paymentType',
        },
        {
          title: 'Durata',
          data: 'duration',
          render: (data: any, type: any, row: any, meta: any) => {
            const durationInMinutes = Number(data);
            const formattedDuration =
              this.getDurationInHoursAndMinutes(durationInMinutes);
            return formattedDuration || '-';
          },
        },
        {
          title: 'Data și ora',
          data: 'startDate',
          render: (data: any, type: any, row: any, meta: any) => {
            const formattedDate = this.datePipe.transform(
              data,
              'dd-MM-yyyy, HH:mm:ss'
            );
            return formattedDate || '-';
          },
        },
      ],
      ajax: (data: any, callback, settings) => {
        this.isLoading = true;

        this.apiService
          .getAllTickets(
            data.search.value,
            data.length,
            data.start,
            this.startDate,
            this.endDate,
            this.currentSortParam
          )
          .subscribe(
            (response: any) => {
              this.ticketsData = response.results.map((row: any) => {
                return {
                  firstName: row.firstName || '-',
                  lastName: row.lastName || '-',
                  email: row.email || '-',
                  licensePlate: row.licensePlate || '-',
                  paymentType: row.paymentType,
                  location: row.zone || '-',
                  duration: row.duration || '-',
                  startDate: row.startDate || '-',
                };
              });

              setTimeout(() => {
                callback({
                  draw: data.draw,
                  data: this.ticketsData,
                  recordsTotal: response.total,
                  recordsFiltered: response.total,
                });
              }, 50);
            },
            (error: any) => {
              console.error('API Error:', error);
              this.isLoading = false;
            }
          );
      },

      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        },
      },
    };
  }

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  isDateRangeSelected(): boolean {
    const startDate = this.form.get('dateRange.start')?.value;
    const endDate = this.form.get('dateRange.end')?.value;
    return !!startDate && !!endDate;
  }

  sortTable(columnName: string) {
    this.currentSortParam =
      this.currentSortParam === `${columnName}|asc`
        ? `${columnName}|desc`
        : `${columnName}|asc`;
  }

  getZoneNameByType(zone: string): string {
    let name = '';

    switch (zone) {
      case 'zone0':
        name = 'Zona 0';
        break;
      case 'zone1':
        name = 'Zona 1';
        break;
      case 'zone2':
        name = 'Zona 2';
        break;
      case 'Parcare supraetajata Crisul':
        name = 'Parcare supraetajata Crisul';
        break;
      default:
        break;
    }
    return name;
  }

  getDurationInHoursAndMinutes(durationInMinutes: number): string {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    let string = '';

    if (hours) string = hours == 1 ? '1 oră' : hours + ' ore';

    if (hours && minutes) string = string + ' și ';

    if (minutes)
      string = minutes == 1 ? string + '1 minut' : string + minutes + ' minute';

    return string;
  }
}
